export const pages = {
	'boltHome': { id: 'boltHome', page: 'home', getter: () => import(/* webpackChunkName: 'home' */ 'components/bolt/home/home') },
	'explainer': { id: 'explainer', page: 'imageTiles', getter: () => import(/* webpackChunkName: 'imageTiles' */ 'components/bolt/imageTiles/imageTiles') },
	'aspectRatioTrailer': { id: 'aspectRatioTrailer', page: 'aspectRatioTrailer', getter: () => import(/* webpackChunkName: 'aspectRatioTrailer' */ 'components/bolt/aspectRatioTrailer/aspectRatioTrailer') }
};
export const sections = [
	{ id: 'boltSynopsis', getter: () => import(/* webpackChunkName: "synopsis" */ 'components/bolt/synopsis/synopsis'), component: 'synopsis', parent: 'boltHome' },
	{ id: 'boltFeaturedVideos', getter: () => import(/* webpackChunkName: "featuredVideos" */ 'components/bolt/featuredVideos/featuredVideos'), component: 'featuredVideos', parent: 'boltHome' }
];
import SidePanelLoader from 'components/bolt/sidePanelLoader/sidePanelLoader';
export { SidePanelLoader };
import VideoOverlayLoader from 'components/bolt/videoOverlayLoader/videoOverlayLoader';
export { VideoOverlayLoader };
